class DevicePostureCheckForm {
    constructor(modalID, formID, devicePostureCheckInfo) {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.modal = document.getElementById(modalID);
        this.form = document.getElementById(formID);
        this.numberOfGroups = devicePostureCheckInfo && devicePostureCheckInfo.groups ? devicePostureCheckInfo.groups.length : 0;
        this.numberOfMembers = devicePostureCheckInfo && devicePostureCheckInfo.members ? devicePostureCheckInfo.members.length : 0;
        this.devicePostureCheckInfo = devicePostureCheckInfo;

        if(this.modal && this.form){
            this.initStepper();
        }
    }
    changeOnFailureMessage(step1Validator){
        const onFailureMessageContainer = this.form.querySelector('.on-failure-message-container');
        const customFailureMessageEl = this.form.querySelector('input[name="customFailureMessage"]');
        const failureMessageRadiosEl = this.form.querySelectorAll('input[name="failureMessage"]');
        const defaultActionRadiosEl = this.form.querySelectorAll('input[name="defaultAction"]');

        for (let defaultActionRadioEl of defaultActionRadiosEl) {
            defaultActionRadioEl.addEventListener('change', function () {
                if(defaultActionRadioEl.value === 'logAction'){
                    onFailureMessageContainer.classList.add('d-none');
                } else {
                    onFailureMessageContainer.classList.remove('d-none');
                }
            });
        }

        for (let failureMessageRadioEl of failureMessageRadiosEl) {
            failureMessageRadioEl.addEventListener('change', function () {
                if(failureMessageRadioEl.value === 'customMessage'){
                    customFailureMessageEl.classList.remove('d-none');
                } else {
                    step1Validator.revalidateField('customFailureMessage');
                    customFailureMessageEl.classList.add('d-none');
                }
            });
        }
    }
    changeAvRunningCheckbox(){
        const windowsRunningAvCheckbox = this.form.querySelector('input[name="windowsRunningAv"]');
        const windowsUpdatedAvCheckbox = this.form.querySelector('input[name="windowsUpdatedAv"]');
        const windowsUpdatedAvCheckboxLabel = this.form.querySelector('label[for="windowsUpdatedAv"]');
        const editWindowsUpdatedAvCheckboxLabel = this.form.querySelector('label[for="editWindowsUpdatedAv"]');
        const label = windowsUpdatedAvCheckboxLabel ? windowsUpdatedAvCheckboxLabel : editWindowsUpdatedAvCheckboxLabel;
        if(label && !windowsRunningAvCheckbox.checked){
            label.classList.add('cursor-not-allowed');
            label.classList.remove('cursor-pointer');
        }
        windowsRunningAvCheckbox.addEventListener('change', (event) => {
            windowsUpdatedAvCheckbox.disabled = !event.currentTarget.checked;
            windowsUpdatedAvCheckbox.checked = false;
            if(!event.currentTarget.checked){
                label.classList.add('cursor-not-allowed');
                label.classList.remove('cursor-pointer');
            } else {
                label.classList.remove('cursor-not-allowed');
                label.classList.add('cursor-pointer');
            }
        });
    }
    initMacOSVersion(){
        const macOSVersionInput = this.form.querySelector('input[name="macOSVersion"]');
        const macOSVersionComparatorSelect = this.form.querySelector('select[name="macOSVersionComparator"]');
        const macOSSupportedVersionOS = this.form.querySelector('input[name="macOSSupportedVersionOS"]');
        const macOSSupportedVersionOSLabel = this.form.querySelector('label[for="'+macOSSupportedVersionOS.id+'"]');
        Inputmask("", {
            mask: "9[9][.9[9][.9[9]]]",
            showMaskOnHover: false,
            showMaskOnFocus: false,
            placeholder: " "
        }).mask('input[name="macOSVersion"]');
        // Disable checkbox on init (when OS version is filled in edit form)
        if(macOSVersionInput.value.length > 0){
            macOSSupportedVersionOS.disabled = true;
        }
        if(macOSSupportedVersionOS.checked){
            macOSVersionInput.disabled = true;
            macOSVersionComparatorSelect.disabled = true;
        }
        macOSVersionInput.addEventListener('input', function() {
            macOSSupportedVersionOS.disabled = (this.value.length > 0);
            if(this.value.length > 0){
                macOSSupportedVersionOSLabel.classList.add('cursor-not-allowed');
                macOSSupportedVersionOSLabel.classList.remove('cursor-pointer');
            } else {
                macOSSupportedVersionOSLabel.classList.remove('cursor-not-allowed');
                macOSSupportedVersionOSLabel.classList.add('cursor-pointer');
            }
        });
        macOSSupportedVersionOS.addEventListener('change', (event) => {
            macOSVersionInput.disabled = event.currentTarget.checked;
            macOSVersionComparatorSelect.disabled = event.currentTarget.checked;
        });
        $(macOSVersionComparatorSelect).select2({
            minimumResultsForSearch: -1
        });
    }
    changeLinuxDiskEncryptionCheckbox(){
        const linuxDiskEncryptionCheckbox = this.form.querySelector('input[name="linuxDiskEncryptionEnabled"]');
        const linuxDiskEncryptionPath = this.form.querySelector('.disk-encryption-path-container');
        if(linuxDiskEncryptionCheckbox){
            linuxDiskEncryptionCheckbox.addEventListener('change', (event) => {
                if(event.currentTarget.checked){
                    linuxDiskEncryptionPath.classList.remove('d-none');
                } else {
                    linuxDiskEncryptionPath.classList.add('d-none');
                }
            });
        }
    }
    initLinuxKernelVersion(){
        const linuxKernelVersionComparatorSelect = this.form.querySelector('select[name="linuxKernelVersionComparator"]');
        Inputmask("", {
            mask: "9[9][.9[9][.9[9]]]",
            showMaskOnHover: false,
            showMaskOnFocus: false,
            placeholder: " "
        }).mask('input[name="linuxKernelVersion"]');
        $(linuxKernelVersionComparatorSelect).select2({
            minimumResultsForSearch: -1
        });
    }
    initLinuxDistribution(){
        const tagsInput = this.form.querySelector('input[name=linuxAllowedDistributions]');
        if(tagsInput){
            let tg = new Tagify(tagsInput, {
                whitelist: ['Debian GNU/Linux', 'Ubuntu', 'Linux Mint', 'CentOS Stream', 'Red Hat Enterprise Linux', 'Fedora Linux', 'Rocky Linux'],
                enforceWhitelist: false,
                skipInvalid: true, // do not temporarily add invalid tags
                edit: true,
                validate(data){
                    return /^[\w\s-]{3,256}$/.test(data.value)
                },
                backspace: "edit",
                dropdown: {
                    classname: "tagify__inline__suggestions",
                    enabled: 0,
                    closeOnSelect: false
                }
            });
            if(this.devicePostureCheckInfo && this.devicePostureCheckInfo['Linux'] && this.devicePostureCheckInfo['Linux']['distribution']){
                tg.addTags(this.devicePostureCheckInfo['Linux']['distribution'], true, true);
            }
            new SpacebarEvent(tg);
        }
    }
    initRepeater(step2Validator){
        const thisClass = this;
        let jQueryForm = $(this.form);

        let initPopovers = function(parentID){
            const popoverTriggerList = [].slice.call(document.querySelectorAll('#'+parentID+' [data-bs-toggle="popover"]'));
            popoverTriggerList.map(function (popoverTriggerEl) {
                new bootstrap.Popover(popoverTriggerEl);
            });
        }

        const keyValidator = {
            validators: {
                notEmpty: {
                    message: 'This field is required'
                },
                stringLength: {
                    max: 256,
                    message: 'Key cannot be over 256 characters',
                },
            }
        },
        valueValidator = {
            validators: {
                notEmpty: {
                    message: 'This field is required'
                },
                stringLength: {
                    max: 256,
                    message: 'Value cannot be over 256 characters',
                },
            }
        },
        locationValidator = {
            validators: {
                notEmpty: {
                    message: 'This field is required'
                },
                stringLength: {
                    max: 256,
                    message: 'Location cannot be over 256 characters',
                },
            }
        },
        nameValidator = {
            validators: {
                notEmpty: {
                    message: 'This field is required'
                },
                stringLength: {
                    max: 256,
                    message: 'Name cannot be over 256 characters',
                },
            }
        },
        comparatorValidator = {
            validators: {
                notEmpty: {
                    message: 'This field is required'
                },
            }
        },
        pathValidator = {
            validators: {
                notEmpty: {
                    message: 'This field is required'
                },
                stringLength: {
                    max: 256,
                    message: 'Path cannot be over 256 characters',
                },
            }
        };

        let windowsRegistryRepeater = jQueryForm.find('#windowsRegistry').repeater({
            initEmpty: true,
            show: function () {
                let keyName = $(this).find("input[name^='windowsRegistry['][name$='][key]']").attr('name');
                let valueName = $(this).find("input[name^='windowsRegistry['][name$='][value]']").attr('name');
                let pathName = $(this).find("input[name^='windowsRegistry['][name$='][path]']").attr('name');
                // let comparator = $(this).find("select[name^='windowsRegistry['][name$='][comparator]']");
                step2Validator.addField(keyName, keyValidator);
                step2Validator.addField(valueName, valueValidator);
                step2Validator.addField(pathName, pathValidator);
                // step2Validator.addField(comparator.attr('name'), comparatorValidator);

                // comparator.select2({minimumResultsForSearch: -1});
                // if(comparator.val() === null){
                //     comparator.val('=').trigger('change');
                // }

                $(this).slideDown();

                initPopovers('windowsRegistry');
            },
            hide: function (deleteElement) {
                let keyName = $(this).find("input[name^='windowsRegistry['][name$='][key]']").attr('name');
                let valueName = $(this).find("input[name^='windowsRegistry['][name$='][value]']").attr('name');
                let pathName = $(this).find("input[name^='windowsRegistry['][name$='][path]']").attr('name');
                // let comparatorName = $(this).find("select[name^='windowsRegistry['][name$='][comparator]']").attr('name');

                $(this).slideUp(deleteElement, function() {
                    step2Validator.removeField(keyName);
                    step2Validator.removeField(valueName);
                    step2Validator.removeField(pathName);
                    // step2Validator.removeField(comparatorName);
                    $(this).remove();
                });
            }
        });
        let windowsFileInSpecificLocationRepeater = jQueryForm.find('#windowsFileInSpecificLocation').repeater({
            initEmpty: true,
            show: function () {
                let name = $(this).find("input[name^='windowsFileInSpecificLocation['][name$='][name]']").attr('name');
                step2Validator.addField(name, locationValidator);

                $(this).slideDown();

                initPopovers('windowsFileInSpecificLocation');
            },
            hide: function (deleteElement) {
                let name = $(this).find("input[name^='windowsFileInSpecificLocation['][name$='][name]']").attr('name');

                $(this).slideUp(deleteElement, function() {
                    step2Validator.removeField(name);
                    $(this).remove();
                });
            }
        });
        let windowsRunningServiceRepeater = jQueryForm.find('#windowsRunningService').repeater({
            initEmpty: true,
            show: function () {
                let name = $(this).find("input[name^='windowsRunningService['][name$='][name]']").attr('name');
                step2Validator.addField(name, nameValidator);

                $(this).slideDown();

                initPopovers('windowsRunningService');
            },
            hide: function (deleteElement) {
                let name = $(this).find("input[name^='windowsRunningService['][name$='][name]']").attr('name');

                $(this).slideUp(deleteElement, function() {
                    step2Validator.removeField(name);
                    $(this).remove();
                });
            }
        });
        let windowsRunningProcessRepeater = jQueryForm.find('#windowsRunningProcess').repeater({
            initEmpty: true,
            show: function () {
                let name = $(this).find("input[name^='windowsRunningProcess['][name$='][name]']").attr('name');
                step2Validator.addField(name, nameValidator);

                $(this).slideDown();

                initPopovers('windowsRunningProcess');
            },
            hide: function (deleteElement) {
                let name = $(this).find("input[name^='windowsRunningProcess['][name$='][name]']").attr('name');

                $(this).slideUp(deleteElement, function() {
                    step2Validator.removeField(name);
                    $(this).remove();
                });
            }
        });
        let macOSFileInSpecificLocationRepeater = jQueryForm.find('#macOSFileInSpecificLocation').repeater({
            initEmpty: true,
            show: function () {
                let name = $(this).find("input[name^='macOSFileInSpecificLocation['][name$='][name]']").attr('name');
                step2Validator.addField(name, locationValidator);

                $(this).slideDown();

                initPopovers('macOSFileInSpecificLocation');
            },
            hide: function (deleteElement) {
                let name = $(this).find("input[name^='macOSFileInSpecificLocation['][name$='][name]']").attr('name');

                $(this).slideUp(deleteElement, function() {
                    step2Validator.removeField(name);
                    $(this).remove();
                });
            }
        });
        let macOSRunningService = jQueryForm.find('#macOSRunningService');
        let macOSRunningServiceRepeater;
        if (macOSRunningService.length) {
            macOSRunningServiceRepeater = macOSRunningService.repeater({
                initEmpty: true,
                show: function () {
                    let name = $(this).find("input[name^='macOSRunningService['][name$='][name]']").attr('name');
                    step2Validator.addField(name, nameValidator);

                    $(this).slideDown();

                    initPopovers('macOSRunningService');
                },
                hide: function (deleteElement) {
                    let name = $(this).find("input[name^='macOSRunningService['][name$='][name]']").attr('name');

                    $(this).slideUp(deleteElement, function () {
                        step2Validator.removeField(name);
                        $(this).remove();
                    });
                }
            });
        }
        let macOSRunningProcess = jQueryForm.find('#macOSRunningProcess');
        let macOSRunningProcessRepeater;
        if (macOSRunningProcess.length) {
            macOSRunningProcessRepeater = macOSRunningProcess.repeater({
                initEmpty: true,
                show: function () {
                    let name = $(this).find("input[name^='macOSRunningProcess['][name$='][name]']").attr('name');
                    step2Validator.addField(name, nameValidator);

                    $(this).slideDown();

                    initPopovers('macOSRunningProcess');
                },
                hide: function (deleteElement) {
                    let name = $(this).find("input[name^='macOSRunningProcess['][name$='][name]']").attr('name');

                    $(this).slideUp(deleteElement, function () {
                        step2Validator.removeField(name);
                        $(this).remove();
                    });
                }
            });
        }
        let linuxFileInSpecificLocation = jQueryForm.find('#linuxFileInSpecificLocation');
        let linuxFileInSpecificLocationRepeater;
        if (linuxFileInSpecificLocation.length) {
            linuxFileInSpecificLocationRepeater = linuxFileInSpecificLocation.repeater({
                initEmpty: true,
                show: function () {
                    let name = $(this).find("input[name^='linuxFileInSpecificLocation['][name$='][name]']").attr('name');
                    step2Validator.addField(name, locationValidator);

                    $(this).slideDown();

                    initPopovers('linuxFileInSpecificLocation');
                },
                hide: function (deleteElement) {
                    let name = $(this).find("input[name^='linuxFileInSpecificLocation['][name$='][name]']").attr('name');

                    $(this).slideUp(deleteElement, function () {
                        step2Validator.removeField(name);
                        $(this).remove();
                    });
                }
            });
        }
        let linuxRunningService = jQueryForm.find('#linuxRunningService');
        let linuxRunningServiceRepeater;
        if (linuxRunningService.length) {
            linuxRunningServiceRepeater = linuxRunningService.repeater({
                initEmpty: true,
                show: function () {
                    let name = $(this).find("input[name^='linuxRunningService['][name$='][name]']").attr('name');
                    step2Validator.addField(name, nameValidator);

                    $(this).slideDown();

                    initPopovers('linuxRunningService');
                },
                hide: function (deleteElement) {
                    let name = $(this).find("input[name^='linuxRunningService['][name$='][name]']").attr('name');

                    $(this).slideUp(deleteElement, function () {
                        step2Validator.removeField(name);
                        $(this).remove();
                    });
                }
            });
        }
        let linuxRunningProcess = jQueryForm.find('#linuxRunningProcess');
        let linuxRunningProcessRepeater;
        if (linuxRunningProcess.length) {
            linuxRunningProcessRepeater = linuxRunningProcess.repeater({
                initEmpty: true,
                show: function () {
                    let name = $(this).find("input[name^='linuxRunningProcess['][name$='][name]']").attr('name');
                    step2Validator.addField(name, nameValidator);

                    $(this).slideDown();

                    initPopovers('linuxRunningProcess');
                },
                hide: function (deleteElement) {
                    let name = $(this).find("input[name^='linuxRunningProcess['][name$='][name]']").attr('name');

                    $(this).slideUp(deleteElement, function () {
                        step2Validator.removeField(name);
                        $(this).remove();
                    });
                }
            });
        }

        const createRepeaterList = function(source, key) {
            if (source && source[key]) {
                let repeaterList = [];
                for (let item of source[key]) {
                    const newItem = {};
                    if (key === 'registryKey') {
                        newItem.key = item.key;
                        newItem.value = item.value;
                        newItem.path = item.path;
                        // newItem.comparator = item.comparator;
                    } else if (key === 'fileLocation') {
                        newItem.name = item.name;
                    } else {
                        newItem.name = item.name;
                    }
                    repeaterList.push(newItem);
                }
                return repeaterList;
            }
            return [];
        }

        /** If this is edit - set the values according to device posture check info */
        if (this.devicePostureCheckInfo) {
            if(this.devicePostureCheckInfo['Windows']){
                const windowsInfo = this.devicePostureCheckInfo['Windows'];

                windowsRegistryRepeater.setList(createRepeaterList(windowsInfo, 'registryKey'));
                windowsFileInSpecificLocationRepeater.setList(createRepeaterList(windowsInfo, 'fileLocation'));
                windowsRunningProcessRepeater.setList(createRepeaterList(windowsInfo, 'processRunning'));
                windowsRunningServiceRepeater.setList(createRepeaterList(windowsInfo, 'serviceRunning'));
            } else if(this.devicePostureCheckInfo['macOS']){
                const macOSInfo = this.devicePostureCheckInfo['macOS'];

                if(macOSFileInSpecificLocationRepeater){
                    macOSFileInSpecificLocationRepeater.setList(createRepeaterList(macOSInfo, 'fileLocation'));
                }
                if(macOSRunningProcessRepeater){
                    macOSRunningProcessRepeater.setList(createRepeaterList(macOSInfo, 'processRunning'));
                }
                if(macOSRunningServiceRepeater){
                    macOSRunningServiceRepeater.setList(createRepeaterList(macOSInfo, 'serviceRunning'));
                }
            } else if(this.devicePostureCheckInfo['Linux']){
                const linuxInfo = this.devicePostureCheckInfo['Linux'];

                if(linuxFileInSpecificLocationRepeater){
                    linuxFileInSpecificLocationRepeater.setList(createRepeaterList(linuxInfo, 'fileLocation'));
                }
                if(linuxRunningProcessRepeater){
                    linuxRunningProcessRepeater.setList(createRepeaterList(linuxInfo, 'processRunning'));
                }
                if(linuxRunningServiceRepeater){
                    linuxRunningServiceRepeater.setList(createRepeaterList(linuxInfo, 'serviceRunning'));
                }
            }
        }
    }
    initStepper(){
        const thisClass = this;

        /** Disable/enable checkbox for updated antivirus if antivirus is running */
        this.changeAvRunningCheckbox();
        /** Init action to change the text on the label when an OS allowed change is made */
        this.changeOsAllowed();

        /** Prevent modal from closing when click outside the modal */
        this.modal.addEventListener('shown.bs.modal', function (event) {
            new DismissModal(thisClass.modal.id).disable(true);
        });

        /** Init stepper with validation */
        const element = this.form.querySelector("#device_posture_check_modal_stepper");
        const stepper = new KTStepper(element);
        const stepValidators = this.createDevicePostureCheckValidation();

        this.changeOnFailureMessage(stepValidators.step1Validator);
        this.initMacOSVersion();
        this.initLinuxKernelVersion();
        this.initLinuxDistribution();
        this.changeLinuxDiskEncryptionCheckbox();

        /** Init all repeaters in form with validation */
        this.initRepeater(stepValidators.step2Validator);

        let continueButton = this.form.querySelector('button[data-kt-stepper-action="next"]');
        let datatableStep = this.form.querySelector('.stepper-item[data-kt-stepper-datatable="true"]');
        let datatableStepAfter = this.form.querySelector('.stepper-item[data-kt-stepper-datatable-after="true"]');
        /** Add loading on continue button */
        let changeContinueButtonStatus = function(loading = false, changeStepDatatableClick = false){
            if(loading){
                // Show loading indication
                continueButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                continueButton.disabled = true;

                if(changeStepDatatableClick){
                    datatableStep.removeAttribute('data-kt-stepper-action');
                    datatableStepAfter.removeAttribute('data-kt-stepper-action');
                }
            } else {
                // Show loading indication
                continueButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                continueButton.disabled = false;

                if(changeStepDatatableClick){
                    datatableStep.setAttribute('data-kt-stepper-action', 'step');
                    datatableStepAfter.setAttribute('data-kt-stepper-action', 'step');
                }
            }
        }
        let initPopovers = function(){
            const popoverTriggerList = [].slice.call(document.querySelectorAll('#'+thisClass.modal.id+' [data-bs-toggle="popover"]'));
            popoverTriggerList.map(function (popoverTriggerEl) {
                new bootstrap.Popover(popoverTriggerEl);
            });
        }
        let membersAndGroupsDatatableInitialized = false;

        /** If you click on a step in the stepper */
        stepper.on("kt.stepper.click", async function (stepper) {
            /** Check if current step is valid */
            let indexToGo = stepper.getClickedStepIndex();
            let isCurrentStepValid = await thisClass.getIfStepIsValid(stepper, stepValidators);
            /** Check if current step is valid */
            if (isCurrentStepValid) {
                /** If clicked step is 3 (add Members & Groups) and members & groups datatable is not initialized */
                if(indexToGo === 3 && !membersAndGroupsDatatableInitialized){
                    /** If step 2 is not valid -> go to step 2 instead of step 3 */
                    if(!await thisClass.getIfStepIsValid(stepper, stepValidators, 2)){
                        stepper.goTo(2);
                    } else {
                        /** initialize datatable, add validation to select at least one member or group and switch to this step */
                        changeContinueButtonStatus(true, true);
                        new MembersAndGroupsDatatable(thisClass.form, thisClass.modal, thisClass.devicePostureCheckInfo?.uuid, thisClass.numberOfMembers, thisClass.numberOfGroups);
                        let datatable = $('#'+thisClass.form.id+' #members-and-groups-datatable');
                        datatable.on('init.dt', function () {
                            stepValidators.setupStep3Validator($(this));
                            membersAndGroupsDatatableInitialized = true;
                            stepper.goTo(indexToGo);
                            changeContinueButtonStatus(false, true);
                            initPopovers();
                        });
                    }
                    /** If the clicked step is step 4 (confirmation), collect all the information from the form and list it in a summary  */
                } else if(indexToGo === 4) {
                    /** If step 2 is not valid -> go to step 2 instead of step 4 */
                    if(!await thisClass.getIfStepIsValid(stepper, stepValidators, 2)){
                        stepper.goTo(2);
                    /** If members datatable is not initialized -> initialize it */
                    } else if(!membersAndGroupsDatatableInitialized){
                        changeContinueButtonStatus(true, true);
                        new MembersAndGroupsDatatable(thisClass.form, thisClass.modal, thisClass.devicePostureCheckInfo?.uuid, thisClass.numberOfMembers, thisClass.numberOfGroups);
                        let datatable = $('#'+thisClass.form.id+' #members-and-groups-datatable');
                        datatable.on('init.dt', async function () {
                            stepValidators.setupStep3Validator($(this));
                            membersAndGroupsDatatableInitialized = true;
                            thisClass.setupLastStepSummary();
                            /** If this step (members datatable) is not valid -> go to step 3, otherwise go to clicked step */
                            if (!await thisClass.getIfStepIsValid(stepper, stepValidators, 3)) {
                                stepper.goTo(3);
                            } else {
                                stepper.goTo(indexToGo);
                            }
                            changeContinueButtonStatus(false, true);
                            initPopovers();
                        });
                    /** If members datatable is not valid -> go to this step */
                    } else if(!await thisClass.getIfStepIsValid(stepper, stepValidators, 3)){
                        stepper.goTo(3);
                    } else {
                        changeContinueButtonStatus(true);
                        thisClass.setupLastStepSummary();
                        stepper.goTo(indexToGo);
                        changeContinueButtonStatus();
                        initPopovers();
                    }
                } else {
                    /** go to clicked step */
                    stepper.goTo(indexToGo);
                    initPopovers();
                }
            /** Don't validate step if stepper go back */
            } else if(stepper.currentStepIndex > indexToGo) {
                stepper.goTo(indexToGo);
            }
        });
        /** Go next */
        stepper.on("kt.stepper.next", async function (stepper) {
            let isCurrentStepValid = await thisClass.getIfStepIsValid(stepper, stepValidators);
            if (isCurrentStepValid) {
                /** If next step is 3 (add Members & Groups) and members & groups datatable is not initialized, initialize it, add validation to select at least one member or group and switch to this step */
                if(stepper.currentStepIndex === 2  && !membersAndGroupsDatatableInitialized){
                    changeContinueButtonStatus(true);
                    new MembersAndGroupsDatatable(thisClass.form, thisClass.modal, thisClass.devicePostureCheckInfo?.uuid, thisClass.numberOfMembers, thisClass.numberOfGroups);
                    let datatable = $('#'+thisClass.form.id+' #members-and-groups-datatable');
                    datatable.on('init.dt', function () {
                        stepValidators.setupStep3Validator($(this));
                        membersAndGroupsDatatableInitialized = true;
                        stepper.goNext();
                        changeContinueButtonStatus();
                        initPopovers();
                    });
                    /** If the next step is step 4 (confirmation), collect all the information from the form and list it in a summary  */
                } else if(stepper.currentStepIndex === 3) {
                    changeContinueButtonStatus(true);
                    thisClass.setupLastStepSummary();
                    stepper.goNext();
                    changeContinueButtonStatus();
                    initPopovers();
                } else {
                    stepper.goNext();
                    initPopovers();
                }
            }
        });
        /** Go previous step */
        stepper.on("kt.stepper.previous", function (stepper) {
            stepper.goPrevious();
        });

        /** Init submit form */
        this.submitForm(stepper, stepValidators);
    }
    changeOsAllowed(){
        const osAllowedElementsArr = [
            this.form.querySelector('input[name="windowsAllowed"]'),
            this.form.querySelector('input[name="linuxAllowed"]'),
            this.form.querySelector('input[name="macOSAllowed"]'),
            this.form.querySelector('input[name="iPadOSAllowed"]'),
            this.form.querySelector('input[name="iOSAllowed"]'),
            this.form.querySelector('input[name="androidAllowed"]')
        ];

        osAllowedElementsArr.forEach((osAllowedElement) => {
            osAllowedElement.addEventListener('change', function(e) {
                let symbolLabel = osAllowedElement.closest('.accordion-item').querySelector('.symbol-label');
                let newText = 'Disallowed';
                if (e.target.checked) {
                    newText = 'Allowed';
                    symbolLabel.classList.remove('filter-grayscale');
                    osAllowedElement.setAttribute("checked", "checked");
                } else {
                    symbolLabel.classList.add('filter-grayscale');
                    osAllowedElement.removeAttribute('checked');
                }
                const labelElement = this.form.querySelector(`label[for='${osAllowedElement.id}']`);
                labelElement.innerText = newText;
            });
        });
    }
    setupLastStepSummary(){
        let formValues = this.getValuesFromForm();

        /** Show/hide alert depends on action */
        let alert = this.form.querySelector('#create-device-posture-check-alert');
        if(formValues.defaultAction === 'logActionAndDenyAccess'){
            alert.classList.remove('d-none');
        } else {
            alert.classList.add('d-none');
        }

        /** Function for creating summary list */
        const createSummarySpecificHTML = function (text, value, customChildClass = null) {
            let returnElement = false;
            let childElements = [];

            if (typeof value === 'boolean') {
                returnElement = value;
            } else if (Array.isArray(value) && value.length !== 0) {
                returnElement = true;
                value.forEach((item) => {
                    if(item){
                        let childText = item;
                        let childClass = 'ps-8';
                        if (typeof item === 'object' && item.hasOwnProperty('key') && item.hasOwnProperty('value') && item.hasOwnProperty('path')) {
                        // if (typeof item === 'object' && item.hasOwnProperty('key') && item.hasOwnProperty('value') && item.hasOwnProperty('path') && item.hasOwnProperty('comparator')) {
                            childText = `${item.key} = ${item.value}`;
                            // childText = `${item.key} ${item.comparator} ${item.value}`;
                            childElements.push(createSummarySpecificHTML(item.path, item.path, childClass));
                            childElements.push(createSummarySpecificHTML(childText, childText, 'ps-16'));
                        } else {
                            childElements.push(createSummarySpecificHTML(childText, childText, childClass));
                        }
                    } else {
                        returnElement = false;
                    }
                });
            } else if (typeof value === 'string') {
                returnElement = (value !== '');
            }

            const createNewListItem = function(text, customChildClass){
                newListItem = document.createElement('li');
                newListItem.className = 'd-flex align-items-center text-break';
                if(customChildClass){
                    newListItem.classList.add(customChildClass);
                }
                let bulletSpan = document.createElement('span');
                bulletSpan.className = 'bullet bg-primary me-5';
                newListItem.appendChild(bulletSpan);
                let textNode = document.createTextNode(text);
                newListItem.appendChild(textNode);
                return newListItem;
            }

            let newListItem;
            if(returnElement){
                newListItem = createNewListItem(text, customChildClass);
                if(childElements.length !== 0){
                    let wrapperItem = document.createElement('div');
                    wrapperItem.className = 'd-flex flex-column text-primary';
                    wrapperItem.appendChild(newListItem);
                    childElements.forEach((childElement, index) => {
                        wrapperItem.appendChild(childElement);
                    });
                    newListItem = wrapperItem;
                }
            }
            return newListItem;
        };
        const clearPoliciesLists = (lists) => {
            lists.forEach(list => list.innerHTML = '');
        };
        const appendToPoliciesList = (list, summaryElement, condition) => {
            if (condition) {
                list.appendChild(summaryElement);
            }
        };
        const createAndAppendSummary = (list, label, value) => {
            const summaryElement = createSummarySpecificHTML(label, value);
            appendToPoliciesList(list, summaryElement, summaryElement);
        };
        const changeBadgeOsStatus = function(element, enabled, enabledWithRestrictions){
            if(enabled){
                element.parentElement.querySelector('.symbol-label').classList.remove('filter-grayscale');
                element.classList.remove('badge-light-danger');
                element.classList.add('badge-light-success');
                element.innerText = 'Allowed'+(enabledWithRestrictions ? ' with restrictions' : '');
            } else {
                element.parentElement.querySelector('.symbol-label').classList.add('filter-grayscale');
                element.classList.add('badge-light-danger');
                element.classList.remove('badge-light-success');
                element.innerText = 'Disallowed';
            }
        };
        const createMembersAndGroupsSymbols = function (members, groups) {
            let html = '<div class="symbol-group symbol-hover flex-wrap mb-3 mt-2">';
            for(let group of groups){
                html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" '+(group['edit'] ? 'id="'+group['uuid']+'"' : '')+'>' +
                    (group['edit'] ? '<div class="edit-group">' : '') +
                    '           <div class="symbol-label bg-light-primary border border-2 border-white text-primary flex-column" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold text-center\'>Group: '+group['name']+'</div><div class=\'text-center\'>'+group['numberOfMembers']+' members</div>">\n' +
                    '               <i class="fa-solid fa-people-group fs-9"></i>' +
                    '               <span class="fs-7">'+group['name'].slice(0, 3)+'</span>' +
                    '           </div>' +
                    (group['edit'] ? '</div>' : '') +
                    '       <span class="symbol-badge badge badge-circle bg-primary start-85 top-85 w-20px h-20px fs-10 text-center text-white">'+group['numberOfMembers']+'</span>' +
                    '    </div>'
            }
            for(let member of members){
                let avatarUrl = '/media/goodaccess/avatars/svg/device.svg';
                if (member['avatarID'] || member['isIdp']) {
                    avatarUrl = '/media/goodaccess/avatars/svg/Icon with face-' + member['avatarID'] + '.svg';
                }

                if (member['password'] || member['isIdp']) {
                    html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" `+(member['edit'] ? 'id="'+member['uuid']+'"' : '')+`>` +
                        (member['edit'] ? '<div class="edit-member">' : '') +
                        `        <div class="symbol-label bg-light-primary border border-2 border-white`+(member['isBlocked'] === 1 ? ' filter-grayscale' : '')+(!member['hasGateway'] ? ' opacity-50' : '')+ `" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="`+ (!member['isIdp'] && !member['avatarID'] ? `<div class='fw-bold text-center'>` + member['username'] + (member['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(member['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+member['managerRole']+`</span>` : ``)+(member['meBadge'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Me</span>` : ``) + `</div>` : `<div class='fw-bold text-center'>` + member['name'] + (member['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(member['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+member['managerRole']+`</span>` : ``)+(member['meBadge'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Me</span>` : ``) + `</div><div class='fw-bold text-center'>` + member['username'] + `</div>`) +`">`+
                        '             <img alt="avatar" class="h-40px" src="' + avatarUrl + '"/>' +
                        '        </div>' +
                        (member['edit'] ? '</div>' : '') +
                        (!member['hasGateway'] ? '<span class="symbol-badge badge badge-circle bg-warning start-85 top-85 w-15px h-15px fs-7 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>This Member is not assigned to any Gateway, so it does not have access to the perimeter</div>">!</span>' : '') +
                        (member['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                        (member['connected'] ? '<span class="symbol-badge badge badge-circle bg-success start-85 top-85 w-15px h-15px" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>connected</div>"></span>' : '') +
                        '     </div>';
                } else {
                    html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300">` +
                        `        <div class="symbol-label bg-light-primary border border-2 border-white`+(member['isBlocked'] === 1 ? ' filter-grayscale' : '')+(!member['hasGateway'] ? ' opacity-50' : '')+`" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="`+ (!member['isIdp'] && !member['avatarID'] ? `<div class='fw-bold text-center'>` + member['username'] + (member['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(member['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+member['managerRole']+`</span>` : ``)+(member['meBadge'] ? `<span class="badge badge-light-danger badge-sm ms-2 align-center">Me</span>` : ``) + `</div>` : `<div class='fw-bold text-center'>` + member['name'] + (member['isBlocked'] ? ' (blocked)' : '') + (member['connected'] ? ' (connected)' : '') + `</div><div class='fw-bold text-center'>` + member['username'] + `</div>`) +`">`+
                        '             <i class="fa-solid fa-user-clock fs-1 '+(member['isBlocked'] === 1 ? 'text-grey-700' : '')+'"></i>'+
                        '        </div>' +
                        (!member['hasGateway'] ? '<span class="symbol-badge badge badge-circle bg-warning start-85 top-85 w-15px h-15px fs-7 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>This Member is not assigned to any Gateway, so it does not have access to the perimeter</div>">!</span>' : '') +
                        (member['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                        '     </div>';
                }
            }
            return html += '</div>'
        };

        const policiesLists = [
            this.form.querySelector('#windows-policies-list'),
            this.form.querySelector('#linux-policies-list'),
            this.form.querySelector('#android-policies-list'),
            this.form.querySelector('#ipados-policies-list'),
            this.form.querySelector('#ios-policies-list'),
            this.form.querySelector('#macos-policies-list')
        ];
        clearPoliciesLists(policiesLists);

        if(formValues.windowsAllowed){
            let list = policiesLists[0];
            createAndAppendSummary(list, 'Supported OS versions only', formValues.windowsSupportedVersionOS);
            createAndAppendSummary(list, 'Supported Client App versions only', formValues.windowsSupportedVersionApp);
            createAndAppendSummary(list, 'Disk encryption enabled', formValues.windowsDiskEncryptionEnabled);
            createAndAppendSummary(list, 'Lock screen with authentication', formValues.windowsLockScreenEnabled);
            createAndAppendSummary(list, 'Running antivirus', formValues.windowsRunningAv);
            createAndAppendSummary(list, 'Updated antivirus', formValues.windowsUpdatedAv);
            createAndAppendSummary(list, 'Firewall enabled', formValues.windowsFirewallEnabled);
            createAndAppendSummary(list, 'Part of a domain', [formValues.windowsDomain]);
            createAndAppendSummary(list, 'Registry key', formValues.windowsRegistry);
            createAndAppendSummary(list, 'File in specific location', formValues.windowsFileInSpecificLocation);
            createAndAppendSummary(list, 'Running service', formValues.windowsRunningService);
            createAndAppendSummary(list, 'Running process', formValues.windowsRunningProcess);
        }
        if(formValues.linuxAllowed){
            let list = policiesLists[1];
            createAndAppendSummary(list, 'Supported Client App versions only', formValues.linuxSupportedVersionApp);
            createAndAppendSummary(list, 'Lock screen with authentication', formValues.linuxLockScreenEnabled);
            createAndAppendSummary(list, 'Firewall enabled', formValues.linuxFirewallEnabled);
            createAndAppendSummary(list, 'Disk encryption enabled', formValues.linuxDiskEncryptionEnabled ? ['Path: '+formValues.linuxDiskEncryptionPath] : false);
            createAndAppendSummary(list, 'Running service', formValues.linuxRunningService);
            createAndAppendSummary(list, 'Running process', formValues.linuxRunningProcess);
            createAndAppendSummary(list, 'Kernel Version '+formValues.linuxKernelVersionComparator+' '+formValues.linuxKernelVersion, formValues.linuxKernelVersion);
            createAndAppendSummary(list, 'Allowed Distributions', formValues.linuxAllowedDistributions);
            createAndAppendSummary(list, 'File in specific location', formValues.linuxFileInSpecificLocation);
        }
        if(formValues.androidAllowed){
            let list = policiesLists[2];
            createAndAppendSummary(list, 'Supported OS versions only', formValues.androidSupportedVersionOS);
            createAndAppendSummary(list, 'Supported Client App versions only', formValues.androidSupportedVersionApp);
            createAndAppendSummary(list, 'Debug mode off', formValues.androidDebugModeOff);
            createAndAppendSummary(list, 'Emulator not allowed', formValues.androidEmulatorNotAllowed);
            createAndAppendSummary(list, 'Biometrics enabled', formValues.androidBiometricsEnabled);
            createAndAppendSummary(list, 'Trusted Execution Environment (TEE) available', formValues.androidEnclave);
            createAndAppendSummary(list, 'Strongbox available', formValues.androidStrongbox);
            createAndAppendSummary(list, 'Rooted device is not allowed', formValues.androidRootedNotAllowed);
            createAndAppendSummary(list, 'Lock screen with authentication', formValues.androidLockScreenEnabled);
        }
        if(formValues.iPadOSAllowed){
            let list = policiesLists[3];
            createAndAppendSummary(list, 'Supported OS versions only', formValues.iPadOSSupportedVersionOS);
            createAndAppendSummary(list, 'Supported Client App versions only', formValues.iPadOSSupportedVersionApp);
            createAndAppendSummary(list, 'Lock screen with authentication', formValues.iPadOSLockScreenEnabled);
        }
        if(formValues.iOSAllowed){
            let list = policiesLists[4];
            createAndAppendSummary(list, 'Supported OS versions only', formValues.iOSSupportedVersionOS);
            createAndAppendSummary(list, 'Supported Client App versions only', formValues.iOSSupportedVersionApp);
            createAndAppendSummary(list, 'Lock screen with authentication', formValues.iPadOSLockScreenEnabled);
        }
        if(formValues.macOSAllowed){
            let list = policiesLists[5];
            createAndAppendSummary(list, 'Supported OS versions only', formValues.macOSSupportedVersionOS);
            createAndAppendSummary(list, 'Supported Client App versions only', formValues.macOSSupportedVersionApp);
            createAndAppendSummary(list, 'Lock screen with authentication', formValues.macOSLockScreenEnabled);
            createAndAppendSummary(list, 'Disk encryption enabled', formValues.macOSDiskEncryptionEnabled);
            createAndAppendSummary(list, 'Firewall enabled', formValues.macOSFirewallEnabled);
            createAndAppendSummary(list, 'OS Version '+formValues.macOSVersionComparator+' '+formValues.macOSVersion, formValues.macOSVersion);
            createAndAppendSummary(list, 'File in specific location', formValues.macOSFileInSpecificLocation);
            createAndAppendSummary(list, 'Running service', formValues.macOSRunningService);
            createAndAppendSummary(list, 'Running process', formValues.macOSRunningProcess);
        }

        changeBadgeOsStatus(this.form.querySelector('#windows-badge-status'), formValues.windowsAllowed, policiesLists[0].hasChildNodes());
        changeBadgeOsStatus(this.form.querySelector('#linux-badge-status'), formValues.linuxAllowed, policiesLists[1].hasChildNodes());
        changeBadgeOsStatus(this.form.querySelector('#android-badge-status'), formValues.androidAllowed, policiesLists[2].hasChildNodes());
        changeBadgeOsStatus(this.form.querySelector('#ipados-badge-status'), formValues.iPadOSAllowed, policiesLists[3].hasChildNodes());
        changeBadgeOsStatus(this.form.querySelector('#ios-badge-status'), formValues.iOSAllowed, policiesLists[4].hasChildNodes());
        changeBadgeOsStatus(this.form.querySelector('#macos-badge-status'), formValues.macOSAllowed, policiesLists[5].hasChildNodes());

        /** Set members & groups */
        let datatable = $('#'+this.form.id+' #members-and-groups-datatable');
        let membersInDevicePostureCheck =  datatable.DataTable().rows(':not(.not-in-device-posture-check.d-none).is-member').data().toArray();
        let groupsInDevicePostureCheck = datatable.DataTable().rows(':not(.not-in-device-posture-check.d-none).is-group').data().toArray();
        let membersGroupsList = this.form.querySelector('#members-groups-list');
        if(membersInDevicePostureCheck.length + groupsInDevicePostureCheck.length > 0){
            membersGroupsList.innerHTML = createMembersAndGroupsSymbols(membersInDevicePostureCheck, groupsInDevicePostureCheck);
        } else {
            membersGroupsList.innerHTML = 'All Members';
        }
    }
    getValuesFromForm() {
        const thisClass = this;
        const getValue = (name, type = 'input', multiple = false) => {
            const selector = `${type}[name="${name}"]${multiple ? ':checked' : ''}`;
            const element = this.form.querySelector(selector);

            if(element){
                if (multiple) {
                    return element ? element.value : false;
                } else {
                    return element ? element.value : '';
                }
            }
            return '';
        };

        const getChecked = (name) => {
            const element = this.form.querySelector(`input[name="${name}"]`);
            return element ? element.checked : false;
        };

        const gerArrayValuesBySelector = (selector) => {
            const elements = thisClass.form.querySelectorAll(selector);
            if(elements.length > 0){
                return Array.from(elements).map(element => element.value);
            }
            return [];
        };
        const gerValueByInputName = (selector) => {
            return thisClass.form.querySelector("input[name='"+selector+"']").value;
        };

        const registryArr = gerArrayValuesBySelector("input[name^='windowsRegistry['][name$='][key]']")
            .map((keyName, index) => ({
                key: keyName,
                value: getValue(`windowsRegistry[${index}][value]`),
                path: getValue(`windowsRegistry[${index}][path]`),
                // comparator: getValue(`windowsRegistry[${index}][comparator]`, 'select'),
            }));

        return {
            name: getValue('name'),
            description: getValue('description', 'textarea'),
            runtimeSchedule: getValue('runtimeSchedule', 'input', true),
            defaultAction: getValue('defaultAction', 'input', true),
            failureMessage: getValue('failureMessage', 'input', true),
            windowsAllowed: getChecked('windowsAllowed'),
            linuxAllowed: getChecked('linuxAllowed'),
            androidAllowed: getChecked('androidAllowed'),
            iOSAllowed: getChecked('iOSAllowed'),
            macOSAllowed: getChecked('macOSAllowed'),
            iPadOSAllowed: getChecked('iPadOSAllowed'),
            windowsSupportedVersionOS: getChecked('windowsSupportedVersionOS'),
            windowsRunningAv: getChecked('windowsRunningAv'),
            windowsUpdatedAv: getChecked('windowsUpdatedAv'),
            windowsFirewallEnabled: getChecked('windowsFirewallEnabled'),
            windowsDiskEncryptionEnabled: getChecked('windowsDiskEncryptionEnabled'),
            windowsLockScreenEnabled: getChecked('windowsLockScreenEnabled'),
            windowsSupportedVersionApp: getChecked('windowsSupportedVersionApp'),
            windowsRegistry: registryArr,
            windowsFileInSpecificLocation: gerArrayValuesBySelector("input[name^='windowsFileInSpecificLocation['][name$='][name]']"),
            windowsRunningService: gerArrayValuesBySelector("input[name^='windowsRunningService['][name$='][name]']"),
            windowsRunningProcess: gerArrayValuesBySelector("input[name^='windowsRunningProcess['][name$='][name]']"),
            windowsDomain: gerValueByInputName("windowsDomain"),
            androidSupportedVersionApp: getChecked('androidSupportedVersionApp'),
            androidSupportedVersionOS: getChecked('androidSupportedVersionOS'),
            androidLockScreenEnabled: getChecked('androidLockScreenEnabled'),
            androidDebugModeOff: getChecked('androidDebugModeOff'),
            androidEmulatorNotAllowed: getChecked('androidEmulatorNotAllowed'),
            androidBiometricsEnabled: getChecked('androidBiometricsEnabled'),
            androidEnclave: getChecked('androidEnclave'),
            androidStrongbox: getChecked('androidStrongbox'),
            androidRootedNotAllowed: getChecked('androidRootedNotAllowed'),
            linuxFirewallEnabled: getChecked('linuxFirewallEnabled'),
            linuxLockScreenEnabled: getChecked('linuxLockScreenEnabled'),
            linuxSupportedVersionApp: getChecked('linuxSupportedVersionApp'),
            linuxRunningService: gerArrayValuesBySelector("input[name^='linuxRunningService['][name$='][name]']"),
            linuxRunningProcess: gerArrayValuesBySelector("input[name^='linuxRunningProcess['][name$='][name]']"),
            linuxKernelVersion: getValue('linuxKernelVersion'),
            linuxKernelVersionComparator: getValue('linuxKernelVersionComparator', 'select'),
            linuxAllowedDistributions: (jsonData => jsonData ? JSON.parse(jsonData).map(item => item.value) : [])(getValue('linuxAllowedDistributions')),
            linuxDiskEncryptionEnabled: getChecked('linuxDiskEncryptionEnabled'),
            linuxDiskEncryptionPath: getValue('linuxDiskEncryptionPath'),
            linuxFileInSpecificLocation: gerArrayValuesBySelector("input[name^='linuxFileInSpecificLocation['][name$='][name]']"),
            macOSSupportedVersionOS: getChecked('macOSSupportedVersionOS'),
            macOSFirewallEnabled: getChecked('macOSFirewallEnabled'),
            macOSDiskEncryptionEnabled: getChecked('macOSDiskEncryptionEnabled'),
            macOSSupportedVersionApp: getChecked('macOSSupportedVersionApp'),
            macOSLockScreenEnabled: getChecked('macOSLockScreenEnabled'),
            macOSVersion: getValue('macOSVersion'),
            macOSVersionComparator: getValue('macOSVersionComparator', 'select'),
            macOSFileInSpecificLocation: gerArrayValuesBySelector("input[name^='macOSFileInSpecificLocation['][name$='][name]']"),
            macOSRunningService: gerArrayValuesBySelector("input[name^='macOSRunningService['][name$='][name]']"),
            macOSRunningProcess: gerArrayValuesBySelector("input[name^='macOSRunningProcess['][name$='][name]']"),
            iPadOSSupportedVersionOS: getChecked('iPadOSSupportedVersionOS'),
            iPadOSLockScreenEnabled: getChecked('iPadOSLockScreenEnabled'),
            iPadOSSupportedVersionApp: getChecked('iPadOSSupportedVersionApp'),
            iOSSupportedVersionOS: getChecked('iOSSupportedVersionOS'),
            iOSLockScreenEnabled: getChecked('iOSLockScreenEnabled'),
            iOSSupportedVersionApp: getChecked('iOSSupportedVersionApp'),
        };
    }
    submitForm(stepper, stepValidators){
        const thisClass = this;
        let submitButton = this.form.querySelector('[data-kt-stepper-action="submit"]');
        /** If the submit button is clicked, check if all steps are valid and if so, submit the form. */
        submitButton.addEventListener('click', async function (e) {
            new DismissModal(thisClass.modal.id).disable();
            // Show loading indication
            submitButton.setAttribute('data-kt-indicator', 'on');
            // Disable button to avoid multiple click
            submitButton.disabled = true;

            let isStep1Valid = await thisClass.getIfStepIsValid(stepper, stepValidators, 1);
            let isStep2Valid = await thisClass.getIfStepIsValid(stepper, stepValidators, 2);
            let isStep3Valid = await thisClass.getIfStepIsValid(stepper, stepValidators, 3);
            if(isStep1Valid && isStep2Valid && isStep3Valid){
                thisClass.form.submit();
            } else {
                new DismissModal(thisClass.modal.id).disable(true);
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            }
        });
    }
    getIfStepIsValid(stepper, stepValidators, stepIndex = null){
        return new Promise((resolve) => {
            switch (stepIndex ?? stepper.currentStepIndex) {
                case 1:
                    stepValidators.step1Validator.validate().then(function (status) {
                        resolve(status === 'Valid');
                    });
                    break;
                case 2:
                    const fields = stepValidators.step2Validator.getFields();

                    const fieldValidationPromises = Object.keys(fields).map((fieldName) => {
                        return stepValidators.step2Validator.validateField(fieldName)
                            .then((status) => {
                                return { fieldName, status };
                            })
                            .catch((error) => {
                                return { fieldName, status: 'Invalid' };
                            });
                    });

                    Promise.all(fieldValidationPromises).then((results) => {
                        resolve(results.every((result) => result.status === 'Valid'));
                    });
                    break;
                case 3:
                    stepValidators.step3Validator.validate().then(function (status) {
                        resolve(status === 'Valid');
                    });
                    break;
                default:
                    resolve(true);
            }
        });
    }
    checkIfPoliciesAreSet(){
        let formValues = this.getValuesFromForm();

        let windowsCheckboxes = [
            formValues.windowsSupportedVersionOS,
            formValues.windowsSupportedVersionApp,
            formValues.windowsDiskEncryptionEnabled,
            formValues.windowsRunningAv,
            formValues.windowsUpdatedAv,
            formValues.windowsFirewallEnabled,
            formValues.windowsLockScreenEnabled
        ];
        let windowsInputs = [
            formValues.windowsDomain,
        ];
        let numberOfAllowedWindowsPolicies = windowsCheckboxes.filter(value => value === true).length + windowsInputs.filter(value => value !== '').length;
        let windowsRepeaters = [
            formValues.windowsRegistry,
            formValues.windowsFileInSpecificLocation,
            formValues.windowsRunningService,
            formValues.windowsRunningProcess
        ];
        let numberOfNonEmptyWindowsRepeaters = windowsRepeaters.filter(obj => Object.keys(obj).length > 0).length;
        let androidCheckboxes = [
            formValues.androidSupportedVersionOS,
            formValues.androidSupportedVersionApp,
            formValues.androidLockScreenEnabled,
            formValues.androidBiometricsEnabled,
            formValues.androidDebugModeOff,
            formValues.androidEmulatorNotAllowed,
            formValues.androidEnclave,
            formValues.androidStrongbox,
            formValues.androidRootedNotAllowed,
        ];
        let numberOfAllowedAndroidPolicies = androidCheckboxes.filter(value => value === true).length;
        let macOSCheckboxes = [
            formValues.macOSSupportedVersionOS,
            formValues.macOSFirewallEnabled,
            formValues.macOSSupportedVersionApp,
            formValues.macOSLockScreenEnabled,
            formValues.macOSDiskEncryptionEnabled
        ];
        let numberOfAllowedMacOSPolicies = macOSCheckboxes.filter(value => value === true).length;
        let macOSRepeaters = [
            formValues.macOSFileInSpecificLocation,
            formValues.macOSRunningService,
            formValues.macOSRunningProcess,
        ];
        let numberOfNonEmptyMacOSRepeaters = macOSRepeaters.filter(obj => Object.keys(obj).length > 0).length;
        let macOSInputs = [
            formValues.macOSVersion
        ];
        let numberOfNonEmptyMacOSInputs = macOSInputs.filter(obj => Object.keys(obj).length > 0).length;
        let iPadOSCheckboxes = [
            formValues.iPadOSLockScreenEnabled,
            formValues.iPadOSSupportedVersionOS,
            formValues.iPadOSSupportedVersionApp
        ];
        let numberOfAllowedIPadOSPolicies = iPadOSCheckboxes.filter(value => value === true).length;
        let iOSCheckboxes = [
            formValues.iOSSupportedVersionApp,
            formValues.iOSSupportedVersionOS,
            formValues.iOSLockScreenEnabled
        ];
        let numberOfAllowedIOSPolicies = iOSCheckboxes.filter(value => value === true).length;
        let linuxCheckboxes = [
            formValues.linuxFirewallEnabled,
            formValues.linuxSupportedVersionApp,
            formValues.linuxLockScreenEnabled,
            formValues.linuxDiskEncryptionEnabled,
        ];
        let linuxRepeaters = [
            formValues.linuxRunningService,
            formValues.linuxRunningProcess,
            formValues.linuxFileInSpecificLocation
        ];
        let linuxInputs = [
            formValues.linuxKernelVersion,
            formValues.linuxDiskEncryptionPath,
        ];
        let numberOfNonEmptyLinuxInputs = linuxInputs.filter(obj => Object.keys(obj).length > 0).length;
        let numberOfNonEmptyLinuxRepeaters = linuxRepeaters.filter(obj => Object.keys(obj).length > 0).length;
        let numberOfAllowedLinuxPolicies = linuxCheckboxes.filter(value => value === true).length + formValues.linuxAllowedDistributions.length;

        let windowsIsSet = formValues.windowsAllowed === false || ((numberOfAllowedWindowsPolicies + numberOfNonEmptyWindowsRepeaters) > 0);
        let linuxIsSet = formValues.linuxAllowed === false || ((numberOfAllowedLinuxPolicies + numberOfNonEmptyLinuxRepeaters + numberOfNonEmptyLinuxInputs) > 0);
        let macOSIsSet = formValues.macOSAllowed === false  || ((numberOfAllowedMacOSPolicies + numberOfNonEmptyMacOSInputs + numberOfNonEmptyMacOSRepeaters) > 0);
        let iPadOSIsSet = formValues.iPadOSAllowed === false || numberOfAllowedIPadOSPolicies > 0;
        let iOSIsSet = formValues.iOSAllowed === false || numberOfAllowedIOSPolicies > 0;
        let androidIsSet = formValues.androidAllowed === false || numberOfAllowedAndroidPolicies > 0;

        return windowsIsSet || linuxIsSet || macOSIsSet || iPadOSIsSet || iOSIsSet || androidIsSet;
    }
    createDevicePostureCheckValidation(){
        let thisClass = this;
        let step1Validator, step2Validator, step3Validator, setupStep3Validator;

        step1Validator = FormValidation.formValidation(this.form,
            {
                fields: {
                    'devicePostureCheckName': {
                        validators: {
                            notEmpty: {
                                message: 'This field is required'
                            },
                            stringLength: {
                                max: 45,
                                message: 'Name cannot be over 45 characters',
                            },
                            regexp: {
                                regexp: /^[^ ][ěščřžýáíéóúůďťňĎŇŤŠČŘŽÝÁÍÉÚŮa-zA-Z0-9\' _.-]*$/,
                                message: 'Only these special characters are allowed. (_-)',
                            },
                        }
                    },
                    'description': {
                        validators: {
                            stringLength: {
                                max: 256,
                                message: 'Description cannot be over 256 characters',
                            },
                        }
                    },
                    'runtimeSchedule': {
                        validators: {
                            notEmpty: {
                                message: 'This field is required'
                            },
                        },
                    },
                    'defaultAction': {
                        validators: {
                            notEmpty: {
                                message: 'This field is required'
                            },
                        },
                    },
                    'customFailureMessage': {
                        validators: {
                            stringLength: {
                                max: 90,
                                message: 'Message cannot be over 90 characters',
                            },
                            callback: {
                                message: 'This field is required',
                                callback: function(input) {
                                    const selectedRadioButton = thisClass.form.querySelector('[name="failureMessage"]:checked');
                                    if(selectedRadioButton.value === 'customMessage'){
                                        return input.value.length !== 0;
                                    }
                                    return true;
                                }
                            }
                        },
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    }),
                    icon: new FormValidation.plugins.Icon({
                        valid: 'fa fa-check',
                        invalid: 'fa fa-times',
                        validating: 'fa fa-refresh',
                        onPlaced: function (e) {
                            if (e.field === 'runtimeSchedule' || e.field === 'defaultAction' || e.field === 'customFailureMessage') {
                                e.iconElement.classList.add('d-none');
                            }
                        },
                    }),
                }
            },
        );

        step2Validator = FormValidation.formValidation(this.form,
            {
                fields: {
                    /** validation added to this input, but in fact it can be added to any input (only some input is needed to trigger validation for the whole form) */
                    'windowsSupportedVersionOS': {
                        validators: {
                            callback: {
                                message: 'Select at least one restriction',
                                callback: function () {
                                    return thisClass.checkIfPoliciesAreSet();
                                },
                            },
                        },
                    },
                    'windowsDomain': {
                        validators: {
                            stringLength: {
                                max: 256,
                                message: 'Domain cannot be over 256 characters',
                            },
                        },
                    },
                    'macOSVersion': {
                        validators: {
                            stringLength: {
                                max: 10,
                                message: 'Version cannot be over 8 characters',
                            },
                            regexp: {
                                regexp: /^(0|[1-9][0-9]?)(\.(0|[1-9][0-9]?)){0,2}$/,
                                message: 'Please enter a valid OS version',
                            },
                        },
                    },
                    'linuxKernelVersion': {
                        validators: {
                            stringLength: {
                                max: 10,
                                message: 'Kernel version cannot be over 8 characters',
                            },
                            regexp: {
                                regexp: /^(0|[1-9][0-9]?)(\.(0|[1-9][0-9]?)){0,2}$/,
                                message: 'Please enter a valid kernel version',
                            },
                        },
                    },
                    'linuxDiskEncryptionPath': {
                        validators: {
                            stringLength: {
                                max: 64,
                                message: 'Disk encryption path cannot be over 64 characters',
                            },
                            regexp: {
                                regexp: /^(\/[^\/\\0]+)+\/?$/,
                                message: 'Please enter a valid path',
                            },
                            callback: {
                                message: 'This field is required',
                                callback: function (input) {
                                    let linuxDiskEncryptionEnabled = thisClass.form.querySelector('input[name="linuxDiskEncryptionEnabled"]').checked;
                                    if (linuxDiskEncryptionEnabled) {
                                        return input.value.length > 0;
                                    }
                                    return true;
                                }
                            }
                        },
                    }
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: '',
                        defaultMessageContainer: false
                    }),
                    message: new FormValidation.plugins.Message({
                        clazz: 'fv-plugins-message-container invalid-feedback',
                        container: function (field, ele) {
                            if (field === 'windowsSupportedVersionOS') {
                                return thisClass.form.querySelector('#atLeastOnePolicy');
                            }
                            return FormValidation.utils.closest(ele, '.fv-row');
                        }
                    }),
                }
            }
        ).on('core.element.validated', function(event) {
            if(event.field !== 'windowsSupportedVersionOS' && !event.valid){
                let accordionEl = thisClass.form.querySelector('input[name="'+event.field+'"]').closest('[data-bs-parent="#kt_accordion_os"]');
                if(!accordionEl.classList.contains('show')){
                    bootstrap.Collapse.getOrCreateInstance(accordionEl).show();
                }
            }
        });

        const revalidateStep2Validator = function () {
            const handleInputChange = () => {
                step2Validator.revalidateField('windowsSupportedVersionOS');
            };

            const inputsInsideAccordion = thisClass.form.querySelectorAll('.kt-accordion-os input');
            inputsInsideAccordion.forEach((input) => {
                input.addEventListener('change', handleInputChange);
            });
        }
        revalidateStep2Validator();

        step3Validator = FormValidation.formValidation(this.form,
            {
                fields: {

                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    }),
                    message: new FormValidation.plugins.Message({
                        clazz: 'fv-plugins-message-container invalid-feedback',
                        container: function (field, ele) {
                            return thisClass.form.querySelector('#atLeastOneMemberOrGroup');
                        },
                    }),
                }
            }
        );

        setupStep3Validator = function(datatable) {
            step3Validator.addField('members[]', {
                validators: {
                    callback: {
                        message: 'Add at least one Member/Group or check "Add all Members"',
                        callback: function (input) {
                            let membersInDevicePostureCheck =  datatable.DataTable().rows(':not(.not-in-device-posture-check.d-none).is-member').data().toArray().length;
                            let groupsInDevicePostureCheck = datatable.DataTable().rows(':not(.not-in-device-posture-check.d-none).is-group').data().toArray().length;
                            let addAllMembers = thisClass.form.querySelector('input[name="addAllMembers"]').checked;

                            return addAllMembers || (membersInDevicePostureCheck + groupsInDevicePostureCheck !== 0);
                        },
                    },
                },
            });
        };
        const revalidateStep3Validator = function () {
            const addAllMembers = thisClass.form.querySelector('input[name="addAllMembers"]');
            const handleInputChange = () => {
                step3Validator.revalidateField('members[]');
            };
            addAllMembers.addEventListener('change', handleInputChange);
        }
        revalidateStep3Validator();

        return {
            step1Validator: step1Validator,
            step2Validator: step2Validator,
            step3Validator: step3Validator,
            setupStep3Validator: setupStep3Validator
        }
    }
}
window.DevicePostureCheckForm = DevicePostureCheckForm;